import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { BaseInquiryDocumentToUploadInterface } from '../_interfaces/base-inquiry-document-to-upload.interface';

@Injectable({ providedIn: 'root' })
export class BaseInquiryDocumentUploadService {
  private documentToUploadSubject = new BehaviorSubject<BaseInquiryDocumentToUploadInterface | null>(null);
  documentToUpload$: Observable<BaseInquiryDocumentToUploadInterface | null> =
    this.documentToUploadSubject.asObservable();

  setDocumentInfo(info: BaseInquiryDocumentToUploadInterface) {
    this.documentToUploadSubject.next(info);
  }

  clearDocumentInfo() {
    this.documentToUploadSubject.next(null);
  }
}
